export const GET_COUNTRY_AND_LANGUAGES = "GET_COUNTRY_AND_LANGUAGES";
export const GET_ANNOUNCEMENT = "GET_ANNOUNCEMENT";
export const GET_FEATURED_PROMOS = "GET_FEATURED_PROMOS";
export const SABA_ODDS = "HOME_SABA_ODDS";
